import { useEffect, useState } from "react";
import { useFeatureFlags } from "../../context/LDFlagsContext";
import { fetchTemplates } from "./protocolsService";
import { subscribeToProtocolTemplatesAvailabilityChanged } from "./protocolTemplatesAvailability";

interface UseProtocolTemplatesTabEnabledParams {
  orgId: string;
  workspaceId: string;
  isWorkspace: boolean;
}

export const useProtocolTemplatesTabEnabled = ({
  orgId,
  workspaceId,
  isWorkspace,
}: UseProtocolTemplatesTabEnabledParams): boolean => {
  const { enableProtocolTemplates } = useFeatureFlags();
  const [hasTemplates, setHasTemplates] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    return subscribeToProtocolTemplatesAvailabilityChanged(() => {
      setRefreshKey((currentRefreshKey) => currentRefreshKey + 1);
    });
  }, []);

  useEffect(() => {
    let isSubscribed = true;

    if (!enableProtocolTemplates || orgId.length === 0) {
      setHasTemplates(false);
      return () => {
        isSubscribed = false;
      };
    }

    const loadTemplateAvailability = async (): Promise<void> => {
      try {
        const templatesData = await fetchTemplates(
          orgId,
          1,
          10,
          false,
          "",
          "",
          isWorkspace,
          workspaceId
        );

        if (isSubscribed) {
          setHasTemplates(templatesData.total > 0);
        }
      } catch (error) {
        console.error("Error checking protocol template availability:", error);

        if (isSubscribed) {
          setHasTemplates(false);
        }
      }
    };

    void loadTemplateAvailability();

    return () => {
      isSubscribed = false;
    };
  }, [enableProtocolTemplates, isWorkspace, orgId, refreshKey, workspaceId]);
  return enableProtocolTemplates && hasTemplates;
};
